module.exports = __webpack_public_path__ + "img/category-fishing-game.b7f9a395.png";